<template>
  <div style="padding-top:0.625rem;">
    <el-row>
      <el-col :span="4">
		  <el-image :src="logoSrc"></el-image>
	  </el-col>
      <el-col :span="16">
		  <ul class="menu_ul">
			  <li @click="toIndex"><span :style="activeIndex==1?'text-decoration: underline;text-underline-position: under;':''">首页</span></li>
			  <li><span>/</span></li>
			  <li @click="toRequirement"><span :style="activeIndex==2?'text-decoration: underline;text-underline-position: under;':''">需求大厅</span></li>
			  <li><span>/</span></li>
			  <li @click="toQiye"><span :style="activeIndex==3?'text-decoration: underline;text-underline-position: under;':''">企业支持</span></li>
			  <li><span>/</span></li>
			  <li @click="toFuwu"><span :style="activeIndex==4?'text-decoration: underline;text-underline-position: under;':''">服务产品</span></li>
			  <li><span>/</span></li>
			  <li @click="toGuanyu"><span :style="activeIndex==5?'text-decoration: underline;text-underline-position: under;':''">关于我们</span></li>
		  </ul>
	  </el-col>
      <el-col :span="4">
		  <template v-if="!loginFlag">
			  <ul class="menu_ul right_menu_ul">
				  <li @click="toLogin"><span>登录</span></li>
				  <li><span>/</span></li>
				  <li @click="toRegister"><span>注册</span></li>
			  </ul>
		  </template>
		  <template v-else>
			  <ul class="menu_ul right_menu_ul" style="list-style-type: none;">
				  <!-- <li>
				  					  <template class="submenu-title" slot="title">
				  					    <el-avatar
				  					      :src="userInfo.avatar && userInfo.avatar != '' ?
				  					      userInfo.avatar : require('../../assets/admin/avatar.png')"/>
				  					    <span class="left-margin">{{userInfo.userName}}</span>
				  					  </template>
				  </li> -->
				  <li @click="toUserCenter" v-if="userInfo.userType=='00'">
				  						<span><i class="el-icon-user-solid"/>企业中心</span>
				  </li>
				  <li @click="toUserCenter" v-if="userInfo.userType=='01'">
				  						<span><i class="el-icon-user-solid"/>个人中心</span>
				  </li>
				  <li @click="logout">
				  		<span><i<i class="el-icon-switch-button"/>退出登录</span>
				  </li>
			  </ul>
		  </template>
	  </el-col>
    </el-row>
  </div>
</template>

<script>
  import {mapState} from "vuex"
  import connect from '@/util/connect.js'

  export default {
    name: 'baseHeader',
    data() {
      return {
        activeIndex: 1,
        logoSrc: require("../../assets/index_new/logo.png")
      }
    },
    computed: {
      ...mapState({
        userInfo: state => state.user.userInfo,
        loginFlag: state => state.user.loginFlag
      }),
    },
	created() {
		if(this.$route.path=='/'){
			this.activeIndex = 1;
		}else if(this.$route.path=='/requirement'){
			this.activeIndex = 2;
		}else if(this.$route.path=='/distribute'){
			this.activeIndex = 3;
		}else if(this.$route.path=='/ecology'){
			this.activeIndex = 4;
		}else if(this.$route.path=='/join'){
			this.activeIndex = 5;
		}
	},
    methods: {
	  // 路由到首页
	  toIndex() {
		this.activeIndex = 1;
	    this.$router.push("/");
	  },
	  // 路由到需求大厅
	  toRequirement() {
		this.activeIndex = 2;
	    this.$router.push("/requirement")
	  },
	  // 路由到企业发包
	  toQiye() {
		this.activeIndex = 3;
	    this.$router.push("/distribute")
	  },
	  // 路由到服务产品
	  toFuwu() {
		this.activeIndex = 4;
	    this.$router.push("/ecology")
	  },
	  // 路由到关于我们
	  toGuanyu() {
		this.activeIndex = 5;
	    this.$router.push("/join")
	  },
		
		
      // 路由到登录页
      toLogin() {
        this.$router.push("/login")
      },
      // 路由到注册页
      toRegister() {
        this.$router.push("/register")
      },
      // 跳转到企业中心
      toUserCenter() {
        window.open("https://admin.kefubang.com", '_blank')
      },
      logout() {
        this.$store.dispatch("LogOut").then(() => {
          this.$message("退出登录！")
        })
      },
	  contact() {
	  	document.getElementById("nb_invite_ok").click();
	  }
    }
  }

</script>
<style>
	ul.menu_ul{padding-left: 11.9375rem;}
	ul.menu_ul li{float:left;list-style-type: none;padding:0 0.625rem;color:white;font-size:0.95rem;cursor: pointer;}
	ul.right_menu_ul{padding-left:0;}
	ul.right_menu_ul li{padding-left:0;}
	
</style>
<style scoped>
  @import "../../assets/css/common.css";

</style>